// ReportDetailsWrapper.jsx or .tsx
import { useParams, useNavigate, useOutletContext } from 'react-router-dom'
import DoNotCallPage from './DoNotCallPage'

const DoNotCallPageWrapper = (props) => {
  const params = useParams()
  const navigate = useNavigate()
  const outletContext = useOutletContext()

  return (
    <DoNotCallPage
      {...params}
      navigate={navigate}
      outletContext={outletContext}
      {...props}
    />
  )
}

export default DoNotCallPageWrapper
